import * as React from "react";
const SvgFiRrMethod = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-method_svg__a)">
      <path
        fill="#062147"
        d="M20.293 17.879A2.98 2.98 0 0 0 18.171 17h-2.757l.793-.793a1 1 0 0 0 0-1.414l-1.914-1.914A2.98 2.98 0 0 0 12.171 12H9.414l.793-.793a1 1 0 0 0 0-1.414L8.293 7.879A2.98 2.98 0 0 0 6.171 7H3c-1.654 0-3 1.346-3 3v1c0 .771.301 1.468.78 2A2.98 2.98 0 0 0 0 15v1c0 .771.301 1.468.78 2A2.98 2.98 0 0 0 0 20v1c0 1.654 1.346 3 3 3h15.171c.801 0 1.555-.312 2.122-.879l1.914-1.914a1 1 0 0 0 0-1.414zm-7.414-3.586 1.207 1.207-1.207 1.207a1 1 0 0 1-.708.293H3c-.551 0-1-.448-1-1v-1c0-.552.449-1 1-1h9.171c.267 0 .519.104.708.293M2 10c0-.552.449-1 1-1h3.171c.267 0 .519.104.708.293L8.086 10.5l-1.207 1.207a1 1 0 0 1-.708.293H3c-.551 0-1-.448-1-1zm16.879 11.707a1 1 0 0 1-.708.293H3c-.551 0-1-.448-1-1v-1c0-.552.449-1 1-1h15.171c.267 0 .519.104.708.293l1.207 1.207zM23.33 7.634l-.549-.317C22.91 6.898 23 6.461 23 6s-.09-.897-.219-1.317l.549-.317a1 1 0 0 0-1-1.732l-.544.314A4.5 4.5 0 0 0 19.5 1.621V1a1 1 0 1 0-2 0v.621a4.5 4.5 0 0 0-2.286 1.327l-.544-.314a1 1 0 0 0-1 1.732l.549.317A4.5 4.5 0 0 0 14 6c0 .461.09.897.219 1.317l-.549.317a1 1 0 0 0 1 1.732l.544-.314a4.5 4.5 0 0 0 2.286 1.327V11a1 1 0 1 0 2 0v-.621a4.5 4.5 0 0 0 2.286-1.327l.544.314A.997.997 0 0 0 23.696 9a1 1 0 0 0-.366-1.366M18.5 8.5A2.503 2.503 0 0 1 16 6c0-1.379 1.122-2.5 2.5-2.5S21 4.621 21 6s-1.122 2.5-2.5 2.5"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-method_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMethod;
